import { App } from "../routes/Constants";
import { FEATURES } from "../constants/permissions.constants";
import { userCanAccess } from "./permissions";

/**
 * Extra navbar items shown when the user has the matching permission(s).
 * Role-based items (Home, Data, Refer Patient, etc.) are added separately in NavBar.
 */
export const PERMISSION_NAV_ITEMS = [
  {
    id: "reporting",
    label: "Reporting",
    url: App.REPORTING,
    feature: FEATURES.REPORTING,
  },
  {
    id: "userManagement",
    label: "User Management",
    url: App.USER_MANAGEMENT,
    feature: FEATURES.USER_MANAGEMENT,
  },
  {
    id: "auditTrail",
    label: "Audit Trail",
    url: App.AUDIT_TRAIL,
    feature: FEATURES.AUDIT_TRAIL,
  },
];

export function getVisibleNavItems(items, user) {
  return items.filter(
    (item) => !item.feature || userCanAccess(user, item.feature)
  );
}

export default PERMISSION_NAV_ITEMS;
